// Generic/free email providers forbidden as company domains.
// Mirrors offood-backend/utils/emailDomains.js (keep in sync).
const GENERIC_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.fr",
  "yahoo.co.uk",
  "ymail.com",
  "hotmail.com",
  "hotmail.fr",
  "outlook.com",
  "outlook.fr",
  "live.com",
  "live.fr",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "gmx.fr",
  "gmx.net",
  "mail.com",
  "zoho.com",
  "yandex.com",
  "yandex.ru",
  "bluewin.ch",
  "sunrise.ch",
  "hispeed.ch",
  "orange.fr",
  "free.fr",
  "wanadoo.fr",
  "laposte.net",
  "sfr.fr",
  "web.de",
  "t-online.de",
]);

export const extractDomain = (value) => {
  if (!value || typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  const domain = normalized.includes("@")
    ? normalized.slice(normalized.lastIndexOf("@") + 1)
    : normalized;
  if (!domain || !domain.includes(".") || /\s/.test(domain)) return null;
  return domain;
};

export const isGenericDomain = (domain) => {
  if (!domain || typeof domain !== "string") return true;
  return GENERIC_DOMAINS.has(domain.trim().toLowerCase());
};
